var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ManualContainer),function(manual,index){return _c('div',{key:index,staticClass:"manual"},[_c('h3',[_vm._v(_vm._s(manual.header))]),_c('br')])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }